import { Pipe, PipeTransform } from '@angular/core';
import { TranslatorService } from '../services/translator.service';

@Pipe({
    name: 'translator',
    pure: false,
    standalone: false
})
export class TranslatorPipe implements PipeTransform {
     constructor(private translator: TranslatorService) { }
     transform(value: string, path: string): unknown {

          return this.translator.getTextForTag(value);
     }

}
